import INVOICE_DOCUMENT_FINANCE_STATE_FIELDS from '../graphql/queries/factoring/invoice-document-finance-state-fields';
import { LAZY_QUERIES_NAMES } from './invoice-lazy-columns';

export const FACTORING_DOCUMENT_FINANCE_STATE_ADDITIONAL_QUERY = {
  [LAZY_QUERIES_NAMES.invoiceDocumentFinanceStateFields.queryKey]: {
    query: INVOICE_DOCUMENT_FINANCE_STATE_FIELDS,
    skip: false,
  },
};

export default FACTORING_DOCUMENT_FINANCE_STATE_ADDITIONAL_QUERY;
